import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { apiNames, get } from '@general/api/shared';

const useMemberTenure = id => {
    const [memberTenure, setMemberTenure] = useState(0);

    useEffect(() => {
        if (!id) return null;

        const fetchMemberTenure = async () => {
            try {
                const response = await get(apiNames.MEMBERSHIP, `members/${id}`);
                const { tenure } = response.data.data;
                setMemberTenure(tenure || 0);
            } catch (error) {
                console.log('error', error);
            }
        };

        fetchMemberTenure();
    }, [id]);

    return memberTenure;
};

useMemberTenure.propTypes = {
    id: PropTypes.string,
};

export default useMemberTenure;
